import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { displayableMediaUrl } from '../widget-lib/media-url';
import { RichTextBlock } from './rich-text-block';

type PromoBannerProps = {
  screen: 'auth' | 'schedule' | 'my_bookings' | 'success' | 'services' | 'trainers';
};

export function PromoBanner({ screen }: PromoBannerProps) {
  const { widgetConfig, guestShowcaseOrg, guestShowcaseLoading } = useEmbedBootstrap();
  const widget = widgetConfig?.widget || guestShowcaseOrg?.settings?.widget;

  // Пока guestShowcaseOrg загружается и widgetConfig отсутствует — ждём
  if (!widget) {
    if (guestShowcaseLoading) return null;
    return null;
  }

  const promoScreens = Array.isArray(widget.promo_screens) ? (widget.promo_screens as string[]) : [];
  const normalizedScreen = (screen === 'services' || screen === 'trainers') ? 'schedule' : screen;
  if (!promoScreens.includes(normalizedScreen)) return null;

  const promoText = typeof widget.promo_text === 'string' ? widget.promo_text.trim() : '';
  const promoImageUrl = typeof widget.promo_image_url === 'string' ? widget.promo_image_url.trim() : '';
  const promoVideoUrl = typeof widget.promo_video_url === 'string' ? widget.promo_video_url.trim() : '';

  const hasText = promoText.length > 0;
  const hasImage = promoImageUrl.length > 0;
  const hasVideo = promoVideoUrl.length > 0;

  if (!hasText && !hasImage && !hasVideo) return null;

  return (
    <div className="mb-4 flex items-stretch gap-4 py-2 transition-all duration-200 h-16 overflow-hidden">
      {hasText && (
        <RichTextBlock
          html={promoText}
          format="markdown"
          className="flex-1 text-xs leading-relaxed text-[var(--text-muted)] min-w-0 self-center line-clamp-3 overflow-hidden"
        />
      )}
      {hasVideo && (
        <div className="relative overflow-hidden rounded-xl bg-black min-w-[10%] max-w-[35%] shrink-0 shadow-inner self-stretch">
          <video
            src={displayableMediaUrl(promoVideoUrl) ?? undefined}
            controls
            autoPlay
            muted
            loop
            playsInline
            className="h-full w-full object-cover"
          />
        </div>
      )}
      {!hasVideo && hasImage && (
        <div className="relative overflow-hidden rounded-xl bg-[var(--bg-soft)] min-w-[10%] max-w-[35%] shrink-0 shadow-sm self-stretch">
          <img
            src={displayableMediaUrl(promoImageUrl) ?? undefined}
            alt="Реклама"
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      )}
    </div>
  );
}
